export function getHost():string{
    return window.location.protocol + "//" + window.location.host;
}